import salesmodule from "../../../Assets/Img/salesmodule.webp";
import erpmodule from "../../../Assets/Img/erpmodule.webp";
import ContactUsForm from "../../../subComponent/ContactUsForm";
import phone from '../../../Assets/Img/phone.png'
import email from '../../../Assets/Img/email.png'
import pinLocation from '../../../Assets/Img/pin-location.png'
import Footer from "../../../subComponent/Footer";
import NavBar from "../../../subComponent/NavBar";
import RequestForm from "../../../subComponent/RequestForm";

const SalesCrm = () => {
    return (
        <div className="bg-white">
            <div className="background-setting top-banner-background">
                <div className="inventory-backdrop" >
                    <div className="py-5">
                        <NavBar />
                        <p className="text-center text-white fs_30  poppins m-0 pb-3  ">Sales & CRM</p>
                        <p className="text-center text-white fs_13  poppins m-0 ">ERP Solution / Inventory & Warehouse Management / Manufacturing</p>
                    </div>
                </div>

            </div>

            <div className="background-setting erp-solution-background my-4">
                <div className="inventory-backdrop" >
                    <div class="line-before text-white fs_19">ERP Solution </div>
                    <div className="container">
                        <div className="py-5 px-5">
                            <p className="sales-text text-white  fs_30 poppins m-0 pb-3   ">SmartB Is A Software ThatGrowsYour Business With You</p>
                            <p className="sales-descrption text-white f  poppins m-0  ls_2  fs_19">SmartB is a modular software that suite your business needs, whatever they may be. Here are some of our latest software features. And if you can’t find a solution that solves your business programs, contact us (click here) to let us know.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sales-module_heading ">
                <p className="benefit-text text-white poppins fs_30">Sales Module</p>
            </div>
            <div className="row w-100 my-5 ">
                <div className=" sales-module-text col-12 col-md-7 p-5">
                    <p className=" text-white  poppins fs_19 ls_2">ERP Sales Module is an integral part of the ERP system. It helps in managing the sales and marketing activities effectively.</p>
                    <p className="text-white poppins fs_19 ls_2">ERP sales modules is one of the most essential elements of a business since it helps handle all business activities for export/ domestic sales of an organization. The customer, as well as product databases, are stored and well-maintained in the ERP sales modules.</p>
                </div>
                <div className="col-12 col-md-5 pt-5 sales-module_image">
                    <img src={salesmodule} width="100%" alt="Your image" />
                </div>
            </div>
            {/* <div className="sales-module_heading">
                <p className="benefit-text text-white poppins fs_30 ">Benefits of Sales Module in ERP:</p>      
                </div> */}

            {/* <div class="skewed-rectangle">
                <div class="skew-corner">
                    <span class="skewed-text">Hello, World!</span>
                </div>
            </div> */}
            {/* <div class="position-relative">
                <div class="skewed-rectangle">
                    <span class="text">Your Text Here</span>
                </div>
            </div> */}

            <div className="row w-100 flex-sm-column-reverse flex-md-row">
                <div className="col-12 col-md-5 pt-5  benefits-module_image">
                    <img src={erpmodule} width="100%" alt="Your image" />
                </div>
                <div className="erp-module-text col-12 col-md-7 p-5">
                    <p className="text-white ls_2  poppins pb-3">The efficient features enable faster task completion and thus driving more leads and enhancing sales performance.</p>
                    <p className="text-white ls_2 poppins pb-3">ERP sales modules is one of the most essential elements of a business since it helps handle all business activities for export/ domestic sales of an organization. The customer, as well as product databases, are stored and well-maintained in the ERP sales modules.</p>
                    <p className="text-white ls_2 poppins pb-3">A strong communication is established between the customers and the sales team helping in getting customer satisfaction and retention.</p>
                    <p className="text-white ls_2 poppins pb-3 ">The sales data can give a better forecasting on your future sales performance.</p>
                    <p className="text-white ls_2 poppins">Order scheduling and tracking delivery ensures the customers are received with products on time, which improves customer ratings.</p>
                </div>


            </div>
            <div className="sales-module_heading crm-module_heading my-5 p-0 ">
                <p className="benefit-text text-white poppins fs_30">CRM Module</p>
            </div>
            <div className="row w-100 my-5  ">
                <div className=" crm-module-text col-12 col-md-7 p-5">
                    <p className=" text-white  poppins fs_19 ls_2">You Know There Is Room For IMPROVEMENT And You Are Searching For It.</p>
                    <p className="text-white poppins fs_19 ls_2">Here’s a Modern ERP Solution For You</p>
                </div>
                <div className="col-12 col-md-5">
                </div>
            </div>
            <div className="px-3 px-md-5 row my-4">
                <div className="col-lg-4 col-md-6 col-sm-12 mx-auto my-3">
                    <div className="service-module_section h-100 Rounded-6 p-3 p-md-5">
                        <p className="services-module-text poppins text-center fs_16">Improve Customer Service</p>
                        <p className="poppins text-black fs_13 ls_2">Happy customers are more likely to be loyal customers and come back more often. So, it’s of utmost importance to know if all of your customers are satisfied. If not, figure out the reasons and fix them. A CRM platform is instrumental in terms of collecting data on customer satisfaction. Some products also incorporate customer service capabilities to further support customers.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mx-auto my-3">
                    <div className=" service-module_section h-100 Rounded-6 p-3 p-md-5 my-3 my-md-0">
                        <p className="services-module-text poppins text-center fs_16">Increase Sales</p>
                        <p className="poppins text-black fs_13 ls_2">A CRM lets you know important customer data such as birthdays, locations, age and industry, which you can use to personalize communication as well as offerings. With the right offers made to the right customers at the optimal time, you can make better deals, resulting in improved ROI.</p>
                    </div>

                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mx-auto my-3">
                    <div className="service-module_section h-100 Rounded-6 p-3 p-md-5">
                        <p className="services-module-text poppins text-center fs_16">Reduce Costs</p>
                        <p className="poppins text-black fs_13 ls_2">You can quickly implement a cloud-based CRM platform without any special installation and hardware requirements, minimizing IT costs and eliminating the need for version control and scheduled updates. CRM pricing is based on the number of users and features needed, making it a cost-effective solution.</p>
                    </div>

                </div>
                {/* </div>
            <div className="sales-service-section px-3 px-md-5 my-3 my-md-5"> */}
                <div className="col-lg-4 col-md-6 col-sm-12 mx-auto my-3">
                    <div className="service-module_section h-100 Rounded-6 p-3 p-md-5">
                        <p className="services-module-text poppins text-center fs_16">Work Remotely</p>
                        <p className="poppins text-black fs_13 ls_2">Keep all users on the same page through a cloud-based CRM system. Remote access enables sales reps to check and update data on the go and work from anywhere.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mx-auto my-3">
                    <div className="service-module_section h-100 Rounded-6 p-3 p-md-5 mt-3 mt-md-0">
                        <p className="services-module-text poppins text-center fs_16">Maximize Customer Lifetime Value</p>
                        <p className="poppins text-black fs_13 ls_2">Understand your customers better and identify cross-selling and upselling opportunities to grow long-lasting and profitable relationships.</p>
                    </div>

                </div>
            </div>
            <RequestForm />

            <div className="background-setting bg-black py-5">
                <Footer />
            </div>
        </div>
    );
}

export default SalesCrm; 